import axios from 'axios';
import get from 'lodash/get';
import axiosConfig from './config';
import { addAxiosInterceptors } from './axiosInstance';
import { DEFAULT_ERROR } from '@utils/errors/serverError';

// TODO: depricate this and merge with axiosInstance

const methods = ['get', 'put', 'post', 'delete', 'patch'];

function successHandler(result) {
  let response = null;
  if (result.request.responseURL.includes(process.env.REACT_APP_API_HOST_GO)) {
    response = result.data;
  } else {
    response = result;
  }

  if (typeof response !== 'object') {
    return response;
  }

  const code = get(response, 'code');
  const status = get(response, 'status');

  if (code && code >= 200 && code < 300) {
    return response.data;
  }
  if (status && status >= 200 && status < 300) {
    return response.data;
  }
  const reject = {
    code: 400,
    message: response.msg || response.message || DEFAULT_ERROR,
  };
  return Promise.reject(reject);
}

function errorHandler(error) {
  const { response } = error;
  let reject;
  if (response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const code = get(response, 'data.errorCode') || get(response, 'status') || 400;

    const message =
      get(response, 'data.details.message') ||
      get(response, 'data.errorMessage') ||
      get(response, 'data.message') ||
      DEFAULT_ERROR;
    reject = {
      code,
      message,
    };
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    reject = {
      code: 400,
      message: error.msg || error.message || DEFAULT_ERROR,
    };
  } else {
    // Something happened in setting up the request that triggered an Error
    reject = {
      message: DEFAULT_ERROR,
    };
  }
  return Promise.reject(reject);
}

function generateMethod(method) {
  return function* methodRequest(url, params, option = {}) {
    const defaultOptions = {
      url,
      method: method.toUpperCase(),
      ...option,
    };
    if (['get', 'delete'].includes(method)) {
      defaultOptions.params = params;
    } else {
      defaultOptions.data = params;
    }
    return yield this.http.request(defaultOptions);
  };
}

class AxiosInstant {
  constructor(config) {
    this.http = axios.create(config);
    addAxiosInterceptors(this.http);
    this.http.interceptors.response.use(successHandler, errorHandler);
  }
}

methods.forEach((method) => {
  AxiosInstant.prototype[method] = generateMethod(method);
});

const http = new AxiosInstant(axiosConfig);

export default http;
